import { apiRequestActionType, apiSuccessActionType, apiErrorActionType, apiResetActionType } from 'utils/API/action-types'

export const CONFIG_INSTALLMENT = 'CONFIG_INSTALLMENT'
export const REQUEST_CONFIG_INSTALLMENT = apiRequestActionType(CONFIG_INSTALLMENT)
export const SUCCESS_CONFIG_INSTALLMENT = apiSuccessActionType(CONFIG_INSTALLMENT)
export const ERROR_CONFIG_INSTALLMENT = apiErrorActionType(CONFIG_INSTALLMENT)
export const RESET_CONFIG_INSTALLMENT = apiResetActionType(CONFIG_INSTALLMENT)